var map = {
	"./bank-transfer.svg": 1853,
	"./betnearn-ico.svg": 1854,
	"./birthday-bonus-ico.svg": 1855,
	"./birthday.svg": 1856,
	"./bonus-code-ico.svg": 1857,
	"./bonus-ico.svg": 1858,
	"./bonus-received-ico.svg": 1859,
	"./bonus.svg": 1860,
	"./business-account-upgrade-ico.svg": 1861,
	"./check-in-daily-ico.svg": 1862,
	"./checked.svg": 1863,
	"./cloud-pointer.svg": 1864,
	"./coin.svg": 1865,
	"./crypto.svg": 1866,
	"./daily-bonus-ico.svg": 1867,
	"./daily-limit.svg": 1868,
	"./deposit-delay-bonus-ico.svg": 1869,
	"./e-wallet.svg": 1870,
	"./earn-x33-coin-ico.svg": 1871,
	"./email.svg": 1872,
	"./facebook.svg": 1873,
	"./feedback.svg": 1874,
	"./first-bet-ico.svg": 1875,
	"./games-rebate-ico.svg": 1876,
	"./info.svg": 1877,
	"./instagram.svg": 1878,
	"./live-casino-rebate-ico.svg": 1879,
	"./lucky-spin-ico.svg": 1880,
	"./messenger.svg": 1881,
	"./mobile-app-deposit-ico.svg": 1882,
	"./monthly-cash.svg": 1883,
	"./msg-activity.svg": 1884,
	"./msg-ann.svg": 1885,
	"./msg-notice.svg": 1886,
	"./new-icon.svg": 1887,
	"./people-ico.svg": 1888,
	"./quick-pay.svg": 1889,
	"./rescue-bonus-ico.svg": 1890,
	"./rescue-lc-ico.svg": 1891,
	"./rescue-slots-ico.svg": 1892,
	"./return.svg": 1893,
	"./sc-bc-active-ico.svg": 1894,
	"./sc-bc-ico.svg": 1895,
	"./sc-bi-active-ico.svg": 1896,
	"./sc-bi-ico.svg": 1897,
	"./sc-mail-active-ico.svg": 1898,
	"./sc-mail-ico.svg": 1899,
	"./sc-mp-active-ico.svg": 1900,
	"./sc-mp-ico.svg": 1901,
	"./sc-pin-active-ico.svg": 1902,
	"./sc-pin-ico.svg": 1903,
	"./slots-rebate-ico.svg": 1904,
	"./sports-rebate-ico.svg": 1905,
	"./telegram.svg": 1906,
	"./twitter.svg": 1907,
	"./vip-up-level-ico.svg": 1908,
	"./vip-weekly-bonus.svg": 1909,
	"./wallet-balance-interest-ico.svg": 1910,
	"./wallet-ico.svg": 1911,
	"./weekly-tournament-ico.svg": 1912,
	"./welcome-bonus-188-ico.svg": 1913,
	"./welcome-bonus-ico.svg": 1914,
	"./whatsapp.svg": 1915,
	"./withdrawal-delay-bonus-ico.svg": 1916,
	"./withdrawal.svg": 1917,
	"./x33-coin.svg": 1918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;